import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  private http = inject(HttpClient);

  private baseUrl = `${environment.apiUrl}/campaign`;

  createCampaign(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  getAllCampaigns() {
    return this.http.get(this.baseUrl);
  }

  getCampaign(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
}